// authReducer.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api.js";

// Centralisation des routes API
const API_ROUTES = {
    ADD_CATEGORY: `/api/category_add`,
    GET_CATEGORY: `/api/category_get`,
};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) => error.response?.data.message || error.message;

// Action pour l'ajout de catégorie
export const categoryAdd = createAsyncThunk(
    "category/categoryAdd",
    async ({ name, image }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('name', name);
            formData.append('image', image);

            //console.log("Données FormData avant l'envoi :", formData.get('name'), formData.get('image'));

            const { data } = await api.post(API_ROUTES.ADD_CATEGORY, formData, { withCredentials: true });
            //console.log("Réponse de l'API :", data); // Log de la réponse de l'API

            return fulfillWithValue(data);
        } catch (error) {
            //console.error("Erreur lors de l'ajout de la catégorie", error);
            //return rejectWithValue(error.response?.data.message || error.message);
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

// Action pour l'ajout de catégorie
export const get_category = createAsyncThunk(
    "category/get_category",
    async ({ searchValue, parPage, page }, { rejectWithValue, fulfillWithValue }) => {
        try {

            const { data } = await api.get(`${API_ROUTES.GET_CATEGORY}?page=${page}&searchValue=${searchValue}
                &parPage=${parPage}`, { withCredentials: true });
           
           //     console.log("Réponse de l'API :", data); // Log de la réponse de l'API

            return fulfillWithValue(data);
        } catch (error) {
            //console.error("Erreur d'acces category", error);
           // return rejectWithValue(error.response?.data.message || error.message);
           return rejectWithValue(getErrorMessage(error));
        }
    }
);


// Reducer principal
export const categoryReducer = createSlice({
    name: 'category',
    initialState: {
        successMessage: '',
        errorMessage: '',
        loader: false,
        categories: [],
        totalCategory: 0
    },
    
    reducers: {
        messageClear: (state) => {
            state.errorMessage = "";
            state.successMessage = "";
        },
    },
    
    extraReducers: (builder) => {
        builder
            .addCase(categoryAdd.pending, (state) => {
                state.loader = true;
                state.errorMessage = '';
            })
            .addCase(categoryAdd.rejected, (state, action) => {
                state.loader = false;
                state.errorMessage = action.payload || "Erreur lors de l'ajout";
            })
            .addCase(categoryAdd.fulfilled, (state, action) => {
                state.loader = false;
                state.successMessage = action.payload.message; // Assurez-vous que 'message' existe dans la réponse
                state.categories = [...state.categories, action.payload.category]
            })

            .addCase(get_category.pending, (state) => {
                state.loader = true;
                state.errorMessage = '';
            })
            .addCase(get_category.rejected, (state, action) => {
                state.loader = false;
                state.errorMessage = action.payload || "Erreur lors de la récupération des catégories";
            })
            .addCase(get_category.fulfilled, (state, action) => {

                state.loader = false;
                //state.successMessage = action.payload.message; // Assurez-vous que 'message' existe dans la réponse
                //state.categories = [...state.categories, action.payload.category]
                state.categories = action.payload.categories;
                state.totalCategory = action.payload.totalCategory;
            });

    }
});

export const { messageClear } = categoryReducer.actions;
export default categoryReducer.reducer;
